import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["attribution", "logoSrc"];
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { Image } from '../Image/Image';
import { StyledPropertyCardMLSLogo } from './PropertyCardMLSLogo.styles';

/**
 * Displays an MLS logo.
 *
 * @since 8.64.2
 */
export var PropertyCardMLSLogo = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var attribution = _ref.attribution,
    logoSrc = _ref.logoSrc,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledPropertyCardMLSLogo, _extends({
    ref: forwardedRef
  }, rest), /*#__PURE__*/React.createElement(Image, {
    src: logoSrc,
    alt: attribution || '',
    "aria-hidden": true
  }));
});
PropertyCardMLSLogo.displayName = 'PropertyCard.MLSLogo';
PropertyCardMLSLogo.propTypes = {
  /**
   * The MLS attribution text. Used for alt text.
   *
   * Ex: alt="Listing provided by NWMLS"
   */
  attribution: PropTypes.string,
  /**
   * The URL for the MLS logo.
   */
  logoSrc: PropTypes.string
};